import React, { useEffect, useMemo, useState } from 'react';
import { Button, Checkbox, MessagePlugin, Space, Table, Dialog, Slider, InputNumber, Row } from 'tdesign-react';
import {
    createKvApi,
    getChatVersion,
    getDouyinAccounts, getKvApi,
    getSimpleTimeGap,
    postLoginDouyin,
    postStartMarketByTaskIdApi,
    postStopMarketByTaskIdApi, 
    setSimpleTimeGap,
    updateKvApi
} from "../api/api";

const version = ["2.0", "2.1"]//插件exe版本管理
const AccountTable = ({
    tasks,
    taskId,
    marketingScript,
    setIsStartAble,
    progress,
    curMarketingTaskId,
    setCurMarketingTaskId,
    options
}) => {
    const [accounts, setAccounts] = useState([{ username: '未登录，第一次登录可能要等待1-5分钟', currentTask: '无', state: 0 }]);
    const [timeGap, setTimeGap] = useState(null); // null means not loaded yet
    const [showSettingsDialog, setShowSettingsDialog] = useState(false);
    const [tempTimeGap, setTempTimeGap] = useState(60); // Temporary value for dialog

    const [isDisabled, setIsDisabled] = useState(false);//判断当前任务是否已经私信完
    const [taskList, setTaskListState] = useState(JSON.parse(localStorage.getItem("tasks")) || []); //TODO:没有意向客户 取出任务keyword和实时更新
    const [isFilteredIntend, setIsFilteredIntend] = useState(false);
    const [isAccountReady, setIsAccountReady] = useState(false); // 是否可以登录抖音账号
    
    // 获取当前私信间隔时间
    const fetchTimeGap = async () => {
        try {
            const response = await getSimpleTimeGap();
            if (response && response.status === 200) {
                setTimeGap(response.time_gap);
                setTempTimeGap(response.time_gap);
            } else {
                // 获取失败，使用默认值 30
                setTimeGap(30);
                setTempTimeGap(30);
            }
        } catch (error) {
            // 获取失败（如404），使用默认值 30
            setTimeGap(30);
            setTempTimeGap(30);
        }
    };
    
    // 保存私信间隔时间设置
    const saveTimeGap = async () => {
        try {
            const response = await setSimpleTimeGap(tempTimeGap);
            if (response && response.status === 200) {
                setTimeGap(response.time_gap);
                MessagePlugin.success('私信间隔时间设置成功');
                setShowSettingsDialog(false);
            } else {
                setTimeGap(null); // 设置为null，表示请求失败
                MessagePlugin.error('私信间隔时间设置失败');
            }
        } catch (error) {
            console.error('Failed to save time gap:', error);
            setTimeGap(null); // 设置为null，表示请求失败
            MessagePlugin.error('私信间隔时间设置失败');
        }
    };

    const updateCurMarketingTask = useMemo(() => { //更新curMarketingTaskId
        if (accounts.length === 0) {
            return [];
        }
        const taskIds = accounts
            .filter(account => account.state === 2 || account.state === 3)
            .map(account => account.task_id);
        return [...new Set(taskIds)];
    }, [accounts]);

    const saveMarketScript = async () => {//保存私信模板
        const back_data = {
            "task_id": taskId,
            "json_key": "marketScript",
            "json_value": marketingScript
        }
        await getKvApi(taskId, "marketScript").then(data => {
            if (data && data.code === 200) {
                if (data.data.length > 5) {
                    updateKvApi(back_data)
                } else {
                    createKvApi(back_data)
                }
            }
        })
    }

    const buttonMap = (account, index) => ({
        0: <Button theme="primary" variant="base" size="medium"
            onClick={() => login(account, index)}>登录抖音账号</Button>,
        1: <Button theme="primary" variant="base" size="medium" disabled={isDisabled}
            onClick={() => startMarketing(account)}>
                {isDisabled ? '私信已完成' : '开始私信'}
            </Button>,
        2: <Button theme="danger" variant="text" size="medium" disabled={isDisabled}
            onClick={() => stopMarketing(account)}>暂停私信</Button>,
        3: <Button theme="danger" variant="text" size="medium" disabled={isDisabled}
            onClick={() => stopMarketing(account)}>暂停私信 {account.update_timestamp}</Button>,
        4: <Button theme="warning" variant="text" size="medium" disabled={isDisabled}>已达上限</Button>,
        5: <Button theme="primary" variant="base" size="medium" disabled>等待登录中</Button>,
    });


    const addAccount = async () => {
        try {
            // First try to access the URL
            const response = await fetch('http://127.0.0.1:3010/get_douyin_accounts', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.status === 200) {
                const data = await response.json();
                if (data && data.status === 200 && data.msg === 'success') {
                    setIsAccountReady(true);
                }
                // If successful, add the account
                if (accounts.length === 0) {
                    setAccounts([{ username: '未登录，第一次登录可能要等待1-5分钟', currentTask: '无', state: 0 }]);
                } else {
                    setAccounts([...accounts, { username: '未登录，第一次登录可能要等待1-5分钟', currentTask: '无', state: 0 }]);
                }
            } else {
                // If failed, trigger the dialog
                setIsStartAble(true);
            }
        } catch (error) {
            // If error occurs (service not running), trigger the dialog
            console.error('Error connecting to private messaging service:', error);
            setIsStartAble(true);
        }
    };

    const columns = [
        {
            title: 
                <Row style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>抖音账号</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox style={{ marginRight: '5px' }} value={isFilteredIntend}
                            onChange={(value) => setIsFilteredIntend(value)} />
                        <span style={{ color: 'black', fontSize: '14px' }}>只私信筛选用户</span>
                    </div>
                </Row>,
            colKey: 'username',
            width: 200
        },
        {
            title: '当前私信任务',
            colKey: 'currentTask',
            width: 150,
            cell: ({ row }) => {
                const isCurrentTask = row.task_id === taskId && row.state === 2;
                return (
                    <span style={{ color: isCurrentTask ? 'blue' : 'black' }}>
                        {row.currentTask} {isCurrentTask ? '（当前任务）' : ''}
                    </span>
                );
            },
        },
        {
            title: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>
                        {timeGap !== null ? 
                            `当前私信间隔 ${timeGap} 秒` : 
                            '单号日限99个，小时限33个'}
                    </span>
                    {timeGap !== null && (
                        <Button theme="primary" size="small" onClick={() => setShowSettingsDialog(true)}>设置</Button>
                    )}
                </div>
            ),
            colKey: 'marketing_count',
            width: 200,
            cell: ({ row }) => {
                const isCurrentTask = row.task_id === taskId && row.state === 2;
                const color = isCurrentTask ? 'green' : row.marketing_count === 50 ? 'orange' : row.marketing_count > 0 ? 'blue' : 'gray';
                const displayCount = row.marketing_count > 0 ? row.marketing_count : 0;
                return (
                    <span style={{ color }}>
                        {displayCount}/99
                    </span>
                );
            },
        },
        {
            title: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>执行操作</span>
                    <Button type="primary" onClick={addAccount}>新增抖音账号</Button>
                </div>
            ),
            colKey: 'actions',
            align: 'center',
            width: 200,
            cell: ({ row, rowIndex }) => (
                isAccountReady
                    ? <Button variant="text" theme="primary" onClick={() => login(row, rowIndex)}>登录抖音账号</Button>
                    : (timeGap === null
                        ? <Button variant="text" theme="primary" onClick={() => setIsStartAble(true)}>下载私信程序（如已经下载请运行）</Button>
                        : buttonMap(row, rowIndex)[row.state]
                    )
            ),
        },
    ];

    const getAllAccounts = async () => {
        await getDouyinAccounts().then(data => {
            if (data && data.data) {
                setIsAccountReady(false); // 只要获取到账号就重置
                const processedAccounts = data.data.accounts.map(account => {
                    const task = taskList.find(t => t.task_id === account.task_id);
                    if (task && account.state !== 1) {
                        account.currentTask = task.keyword;
                    } else {
                        account.currentTask = '无';
                    }
                    if (account.update_timestamp) {
                        account.update_timestamp = calculateCountdown(account.update_timestamp);
                    }
                    return account;
                });
                setAccounts(processedAccounts);
            }
        })
    };


    const login = async (account, index) => {
        console.log(account);

        let isStateReset = false;  // 标记是否已经通过 getAllAccounts 修改 state

        // 点击后将 accounts[index].state 设置为 5（表示禁用）
        setAccounts(prevAccounts => {
            const updatedAccounts = [...prevAccounts];
            updatedAccounts[index].state = 5;
            return updatedAccounts;
        });

        // 启动 15 秒倒计时后恢复 accounts[index].state（如果没有通过 getAllAccounts 修改过 state）
        setTimeout(() => {
            if (!isStateReset) {
                setAccounts(prevAccounts => {
                    const updatedAccounts = [...prevAccounts];
                    updatedAccounts[index].state = 0;  // 恢复为初始状态
                    return updatedAccounts;
                });
            }
        }, 120000);

        // 登录请求，等待结果但不影响按钮解禁
        try {
            const data = await postLoginDouyin();
            if (data && data !== 10000) {
                if (data === 500) {
                    MessagePlugin.warning('登录失败');
                } else {
                    getAllAccounts();
                    isStateReset = true;  // 一旦 getAllAccounts 执行，标记为 true
                }
            } else if (data === 10000) {
                setIsStartAble(true);
            }
        } catch (err) {
            if (err.message && err.message.includes('status: 500')) {
                MessagePlugin.error('登录失败');
            } else {
                setIsStartAble(true);
            }
        }
    };


    const startMarketing = (account) => {//开始私信
        let back_data = {
            user_id: account.user_id,
            task_id: taskId,
            message_text: marketingScript
        }
        if (isFilteredIntend) {
            if (options.ip_location !== '全选') {
                back_data = { ...back_data, "ip_location": options.ip_location }
            }
            if (!isNaN(options.start_time && !isNaN(options.end_time))) {
                back_data = { ...back_data, "start_time": options.start_time, "end_time": options.end_time }
            }
        }
        postStartMarketByTaskIdApi('dy', back_data).then(data => {
            if (data && data.status === 200) {
                getAllAccounts()
                setCurMarketingTaskId(prevTaskIds => {//新增正在运行的任务
                    if (!prevTaskIds.includes(taskId)) {
                        return [...prevTaskIds, taskId];
                    }
                    return prevTaskIds;
                });
            } else if (data === 10000) {
                setIsStartAble(true)
            }
        })
            .catch(err => {
                if (err.message && err.message.includes('status: 402')) {
                    MessagePlugin.error('冷却中，请稍后');
                } else {
                    setIsStartAble(true);
                }
            }
            );
        saveMarketScript()
    }

    const stopMarketing = (account) => {
        const back_data = {
            user_id: account.user_id,
            task_id: taskId
        }
        postStopMarketByTaskIdApi('dy', back_data).then(data => {
            if (data && data.status === "success") {
                // getAllAccounts();
                setAccounts(prevAccounts => {// 在 accounts 中找到对应的 account 并修改其 currentTask 和 state（因为延后更新）
                    return prevAccounts.map(acc => {
                        if (acc.user_id === account.user_id) {
                            return {
                                ...acc,
                                currentTask: "无",
                                state: 1
                            };
                        }
                        return acc;
                    });
                });
                setCurMarketingTaskId(prevTaskIds => {//去除停止的任务
                    return prevTaskIds.filter(id => id !== taskId);
                });
            } else if (data === 10000) {
                setIsStartAble(true)
            }
        })
    }

    const calculateCountdown = (timestamp) => {//计算剩余时间
        // 将时间戳加上2小时（2小时 = 2 * 60 * 60 * 1000 毫秒）
        const updatedTimestamp = timestamp + 55 * 60 * 1000;
        const currentTime = Date.now();
        const countdown = updatedTimestamp - currentTime;
        const hours = Math.floor(countdown / (1000 * 60 * 60));
        const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((countdown % (1000 * 60)) / 1000);

        return `${hours}小时 ${minutes}分钟 ${seconds}秒`;
    }

    useEffect(() => {//提醒用户开插件和检查版本
        const checkServiceAndVersion = async () => {
            try {
                // First try to access the URL directly
                const response = await fetch('http://127.0.0.1:3010/get_douyin_accounts', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                
                if (response.status === 200) {
                    // If we can access the URL, check the version
                    const versionData = await getChatVersion();
                    if (versionData.status === 200 && !version.includes(versionData.version)) {
                        // Only show dialog if version is incompatible
                        setIsStartAble(true);
                    }
                } else {
                    // If we can't access the URL, don't show the dialog yet
                    console.log('Private messaging service not accessible, but not showing dialog yet');
                }
            } catch (error) {
                // If error occurs (service not running), don't show the dialog yet
                console.error('Error connecting to private messaging service:', error);
            }
        };
        
        checkServiceAndVersion();
    }, []);

    useEffect(() => {
        setCurMarketingTaskId(updateCurMarketingTask)
    }, [updateCurMarketingTask]);

    useEffect(() => {//使用progress判断已完成
        if (progress === "100.00" || !taskId) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [progress, taskId]);

    useEffect(() => {//使用tasks设置账号
        setTaskListState(tasks)
        getAllAccounts()
        fetchTimeGap() // 获取当前私信间隔时间
    }, [tasks]);

    useEffect(() => {//根据curMarketingTaskId来决定要不要请求进度
        let intervalId;
        if (curMarketingTaskId.length > 0 && curMarketingTaskId.includes(taskId)) {
            intervalId = setInterval(() => {
                getAllAccounts();
            }, 10000);
        } else {
            if (intervalId) clearInterval(intervalId);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [curMarketingTaskId]);


    return (
        <>
            <Table columns={columns} data={accounts} rowKey={(row, index) => index} bordered maxHeight={1000} />
            
            {/* 私信间隔设置对话框 */}
            <Dialog
                header="私信间隔设置"
                visible={showSettingsDialog}
                onConfirm={saveTimeGap}
                onClose={() => setShowSettingsDialog(false)}
                destroyOnClose
            >
                <Space direction="vertical" style={{ width: '100%', padding: '16px 0' }}>
                    <div>请设置私信间隔时间（0-300秒）：</div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                        <Slider
                            min={0}
                            max={300}
                            step={1}
                            value={tempTimeGap}
                            onChange={value => setTempTimeGap(value)}
                            style={{ flex: 1, marginRight: '16px' }}
                        />
                        <InputNumber
                            min={0}
                            max={300}
                            value={tempTimeGap}
                            onChange={value => setTempTimeGap(value)}
                            style={{ width: '120px' }}
                        />
                    </div>
                </Space>
            </Dialog>
        </>
    );
};

export default AccountTable;
